import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import { Button } from 'react-bootstrap';

const ButtonHideCompleted = ({
  isCompleteItemHidden,
  toggleDisplayCompleted,
  searching,
  completeItemsCount,
  itemName
}) => (
  <Button
    variant={!isCompleteItemHidden ? 'info' : 'light'}
    onClick={toggleDisplayCompleted}
    disabled={searching}
  >
    {!isCompleteItemHidden
      ? `Hide Completed ${capitalize(itemName)}`
      : `Show Completed ${capitalize(itemName)}`}{' '}
    ({completeItemsCount})
  </Button>
);

ButtonHideCompleted.propTypes = {
  isCompleteItemHidden: PropTypes.bool.isRequired,
  toggleDisplayCompleted: PropTypes.func.isRequired,
  completeItemsCount: PropTypes.number.isRequired,
  searching: PropTypes.bool.isRequired,
  itemName: PropTypes.string.isRequired
};
export default ButtonHideCompleted;
